import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components/typography/typography';

type MessagePorTypes = {
  title: string;
  text: string;
  visible?: boolean;
  variant: 'success' | 'warning';
};

const Message: React.FC<MessagePorTypes> = (props) => {
  const { variant, text, title, visible } = props;

  const containerClassName = twMerge(
    'container w-full justify-start items-center',
    'text-gray900 my-4 border-2',
    'rounded-lg px-10 py-5',
    variant === 'success'
      ? 'bg-success-100 border-success-200'
      : 'bg-warning-100 border-warning-200',
  );

  return (
    <>
      {visible ? (
        <div className={containerClassName}>
          <>
            <Typography variant="page-subheading" as="h2" className="mb-2">
              {title}
            </Typography>
            <Typography variant="body-large" as="h3">
              {text}
            </Typography>
          </>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Message;
